import React from 'react'
import './App.css';
import { BrowserRouter as Router, Switch, Route, useHistory } from 'react-router-dom';
import SearchNav from './function-components/Searchnav';
import Navbarmenu from './function-components/Navbarmenu';
import Footer from './function-components/Footer';
import { MsalProvider } from "@azure/msal-react";
import { CustomNavigationClient } from "./utils/NavigationClient";
import { PageLayout } from './function-components/PageLayout';
import Dashboard from "./pages/Dashboard";
import ProjectMaster from './function-components/ProjectMaster';
import DailyTaskUpdate from './function-components/DailyTaskUpdate';
import ProjectMasterNew from './function-components/ProjectMasterNew';
import ProjectControlTab from './function-components/ProjectControlTab';
import ProjectStatus from './function-components/ProjectStatus';
import TeamStatus from './function-components/TeamStatus';
import UserMaintenance from './function-components/UserMaintenance';
import ProjectArtifacts from './function-components/ProjectArtifacts';
import ReviewsPage from './function-components/ReviewsPage';

function App({ pca }) {
  // The next 3 lines are optional. This is how you configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in your app
  const history = useHistory();
  const navigationClient = new CustomNavigationClient(history);

  pca.setNavigationClient(navigationClient);

  return (
    <MsalProvider instance={pca}>
      <PageLayout>
        <div container justifyContent="center">
          <Pages />
        </div>
      </PageLayout>
    </MsalProvider>
  );
}

function Pages() {
  return (
    <>
      <Router basename={"/ProjectTracker"}>
        <SearchNav />
        <Navbarmenu />
        <Switch>
          <Route exact path="/dashboard">
            <Dashboard />
          </Route>
          <Route exact path="/projectMaster">
            {/* <ProjectMaster/> */}
            {/* <ProjectMasterNew/> */}
            <ProjectControlTab/>
          </Route>
          <Route exact path="/dailyTaskUpdate">
            <DailyTaskUpdate/>
          </Route>
          <Route exact path="/individualTaskDashboard">
            <ProjectStatus/>
          </Route>
          <Route exact path="/teamStatus">
           <TeamStatus/>
          </Route>
          <Route exact path="/userMaintenance">
         <UserMaintenance/>
          </Route>
          <Route exact path="/ProjectArtifacts">
         <ProjectArtifacts/>
          </Route> 
          <Route exact path="/ProjectArtifacts/Reviews">
         <ReviewsPage/>
          </Route> 
          <Route exact path="/">
            <Dashboard />
          </Route>
        </Switch>
        <Footer />
      </Router>
    </>
  )
}

export default App;
